var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RsConsoleLog',{attrs:{"query-conf":_vm.props}})}
var staticRenderFns = []

export { render, staticRenderFns }